// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CUSTOM OHIF SCROLLBAR */
.ohif-scrollbar {
  scrollbar-color: #173239 transparent;
  scrollbar-gutter: stable;
}
.study-min-height {
  min-height: 450px;
}
.ohif-scrollbar:hover {
  overflow-y: auto;
}
.ohif-scrollbar::-webkit-scrollbar {
  width: 8px;
}
.ohif-scrollbar::-webkit-scrollbar-track {
  border-radius: 0.25rem;
}
.ohif-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgba(9, 68, 179, var(--tw-bg-opacity));
  background-color: #173239;
}
.ohif-scrollbar::-webkit-scrollbar-thumb:window-inactive {
  --tw-bg-opacity: 1;
  background-color: rgba(9, 68, 179, var(--tw-bg-opacity));
  background-color: #173239;
}
/* INVISIBLE SCROLLBAR */
.invisible-scrollbar {
  scrollbar-width: none;
}
.invisible-scrollbar::-webkit-scrollbar {
  display: none;
}
.invisible-scrollbar::-webkit-scrollbar-track {
  display: none;
}
.invisible-scrollbar::-webkit-scrollbar-thumb {
  display: none;
}
.invisible-scrollbar::-webkit-scrollbar-thumb:window-inactive {
  display: none;
}
.bg-secondary-dark {
  background-color: #0f172a;
}
.bg-primary-dark {
  background-color: #0a0f1c;
}
.hover\\:border-primary-light:hover,
.border-primary-active,
.border-primary-light {
  border-color: #fff;
}
.bg-primary-light {
  /* background-color: #007bff; */
  background-color: #fff;
}
.border-secondary-dark {
  --tw-border-opacity: 1;
  border-color: #0f172a;
}
/* .text-black {
  color: #fff;
} */
.focus\\:text-black:focus,
.hover\\:text-primary-light:hover {
  --tw-text-opacity: 1;
  color: #007bff;
}
.text-blue-100,
.text-blue-200,
.text-blue-300,
.text-blue-300,
.text-blue-400,
.text-blue-500,
.text-blue-600,
.text-primary-light,
.text-primary-active,
.text-\\[\\#348cfd\\] {
  --tw-text-opacity: 1;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/assets/styles/styles.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,UAAU;AACZ;AAGE;EAAA;AAAc;AAId;EAAA,sBAAc;EACd,kBAAsB;EAAtB,wDAAsB;EACtB;AAFc;AAMd;EAAA,kBAAsB;EAAtB,wDAAsB;EACtB;AADsB;AAIxB,wBAAwB;AACxB;EACE,qBAAqB;AACvB;AAGE;EAAA;AAAa;AAIb;EAAA;AAAa;AAIb;EAAA;AAAa;AAIb;EAAA;AAAa;AAGf;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;AAC3B;AAEA;;;EAGE,kBAAkB;AACpB;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AAEA;;GAEG;AAEH;;EAEE,oBAAoB;EACpB,cAAc;AAChB;AAEA;;;;;;;;;;EAUE,oBAAoB;EACpB,WAAW;AACb","sourcesContent":["/* CUSTOM OHIF SCROLLBAR */\n.ohif-scrollbar {\n  scrollbar-color: #173239 transparent;\n  scrollbar-gutter: stable;\n}\n\n.study-min-height {\n  min-height: 450px;\n}\n\n.ohif-scrollbar:hover {\n  overflow-y: auto;\n}\n\n.ohif-scrollbar::-webkit-scrollbar {\n  width: 8px;\n}\n\n.ohif-scrollbar::-webkit-scrollbar-track {\n  @apply rounded;\n}\n\n.ohif-scrollbar::-webkit-scrollbar-thumb {\n  @apply rounded;\n  @apply bg-primary-main;\n  background-color: #173239;\n}\n\n.ohif-scrollbar::-webkit-scrollbar-thumb:window-inactive {\n  @apply bg-primary-main;\n  background-color: #173239;\n}\n\n/* INVISIBLE SCROLLBAR */\n.invisible-scrollbar {\n  scrollbar-width: none;\n}\n\n.invisible-scrollbar::-webkit-scrollbar {\n  @apply hidden;\n}\n\n.invisible-scrollbar::-webkit-scrollbar-track {\n  @apply hidden;\n}\n\n.invisible-scrollbar::-webkit-scrollbar-thumb {\n  @apply hidden;\n}\n\n.invisible-scrollbar::-webkit-scrollbar-thumb:window-inactive {\n  @apply hidden;\n}\n\n.bg-secondary-dark {\n  background-color: #0f172a;\n}\n\n.bg-primary-dark {\n  background-color: #0a0f1c;\n}\n\n.hover\\:border-primary-light:hover,\n.border-primary-active,\n.border-primary-light {\n  border-color: #fff;\n}\n\n.bg-primary-light {\n  /* background-color: #007bff; */\n  background-color: #fff;\n}\n\n.border-secondary-dark {\n  --tw-border-opacity: 1;\n  border-color: #0f172a;\n}\n\n/* .text-black {\n  color: #fff;\n} */\n\n.focus\\:text-black:focus,\n.hover\\:text-primary-light:hover {\n  --tw-text-opacity: 1;\n  color: #007bff;\n}\n\n.text-blue-100,\n.text-blue-200,\n.text-blue-300,\n.text-blue-300,\n.text-blue-400,\n.text-blue-500,\n.text-blue-600,\n.text-primary-light,\n.text-primary-active,\n.text-\\[\\#348cfd\\] {\n  --tw-text-opacity: 1;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
